import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';
import Typography from '@mui/material/Typography';
import { alpha, useTheme } from '@mui/material/styles';
import { useResponsive } from 'src/hooks/use-responsive';

export default function BrandingHero() {
  const theme = useTheme();
  const mdUp = useResponsive('up', 'md');
  const [scrollOpacity, setScrollOpacity] = useState(0);


  useEffect(() => {
    const handleScroll = () => {
      let opacity = window.scrollY / 250;
      if(opacity > 1) opacity = 1;
      setScrollOpacity(opacity);
    }

    window.addEventListener("scroll", handleScroll);
    
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'relative',
        pt: 18,
        pb: { xs: 10, md: 15 },
        display: { md: 'flex' },
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: { md: '100vh' },
        overflow: 'hidden',
      }}
    >
      {/* Video katmanı: poster özelliği veya doğrudan img fallback */}
      <video
        autoPlay
        loop
        muted
        playsInline
        poster="/assets/background/bg-safari.jpg"
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -1,
        }}
      >
        <source src="/assets/background/video.mp4" type="video/mp4" />
        {/* Fallback metni: Tarayıcı video etiketini desteklemiyorsa bu görünür */}
      </video>

      {/* Overlay katmanı */}
      <Box
        sx={{
          position: 'absolute',
          inset: 0,
          background: `linear-gradient(
            to bottom,
            ${alpha(theme.palette.common.black, 0.2)} 0%,
            ${theme.palette.grey[900]} 95%
          )`,
        }}
      />

      {/* İçerik katmanı */}
      <Container id="branding">
        <Grid container spacing={3} justifyContent="space-between" alignItems="center">
          <Grid
            xs={12}
            md={6}
            lg={6}
            sx={{
              color: 'common.white',
              textAlign: { xs: 'center', md: 'left' },
              opacity: 0.95,
            }}
          >
            <Typography
              variant="overline"
              sx={{ color: 'secondary.main', mb: 2, display: 'block', opacity: 0.95 }}
            >
              Dein Partner für Digitalisierung!
            </Typography>

            <Typography variant="h2" component="h1">
              {`Digitale  `}
              <Box
                component="span"
                sx={{
                  color: 'transparent',
                  background: 'linear-gradient(to bottom right, #60feec, #653bff)',
                  WebkitBackgroundClip: 'text',
                  backgroundClip: 'text',
                  opacity: 0.95,
                }}
              >
                zukunft
              </Box>
              {` gestalten!`}
            </Typography>

            <Typography sx={{ mt: 3, mb: 1, opacity: 0.95 }}>
              In einer Welt, in der Digitalstrategien und KI-gestützte Agenten den Erfolg bestimmen, unterstützen wir Dich bei jedem Schritt Deiner Transformation. Von der ersten Idee bis zur finalen Umsetzung – wir bieten Dir individuelle Konzepte und kreative Lösungen, damit Du auch morgen in einer vernetzten Welt wettbewerbsfähig bleibst.
            </Typography>

            <Stack
              spacing={3}
              direction={{ xs: 'column', sm: 'row' }}
              alignItems={{ xs: 'center', md: 'unset' }}
              justifyContent={{ xs: 'center', md: 'unset' }}
              sx={{ mt: 2 }}
            >
              <Button
                variant="outlined"
                size="medium"
                sx={{
                  marginTop: 3,
                  padding: '15px 25px',
                  fontWeight: 400,
                  fontSize: '15px',
                  textTransform: 'unset',
                  color: 'common.white',
                  borderColor: 'common.white',
                  width: 'fit-content',
                }}
                href="/agentur/kontakt"
              >
                Lass uns eine Safari planen!
              </Button>
            </Stack>
          </Grid>

          {/* Opsiyonel: Bei Bedarf ein Bild/Illustration im rechten Bereich einfügen */}
          {/* {mdUp && (
            <Grid xs={12} md={6} lg={6}>
              <Image
                alt="marketing market"
                src="/assets/illustrations/illustration_marketing_market.svg"
              />
            </Grid>
          )} */}
        </Grid>
      </Container>
    </Box>
  );
}
